<template>
    <div class="gift-ideas-container">
        <div class="top-white-box"></div>
        <div class="gift-ideas-loading" v-show="isLoading">
            <button :disabled="true">
                <span class="icon"><img :src="`/Assets/img/spin.svg`" /></span>
            </button>
            <div>Loading</div>
        </div>
        <div class="gift-ideas-list-title" v-if="!isClean && articleDetails">
            <h1>{{ articleDetails.title }}</h1>
        </div>
        <div class="gift-ideas-list-img" v-if="!isClean && articleDetails"><img :src="articleDetails.imgUrl"
                alt="articleDetails.title" /></div>
        <div class="gift-ideas-list-desc" v-if="!isClean && articleDetails">{{ articleDetails.desc }}</div>
        <div v-if="articleDetails" class="article-deals-container">
            <Deals :listOfDeals="articleDetails.deals" :showPrice="false"></Deals>
        </div>

        <div class="top-gray-box" v-if="articleDetails">
            <h1>Other Gift Ideas You Might Like</h1>
        </div>
        <Articles :excludeArticles="Number($route.params.id)" v-if="articleDetails" />
    </div>
</template>

<script lang="ts">
import { defineComponent, ref, onMounted } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import api from '@/api'
import settings from '@/settings'
import Articles from "@/components/Articles.vue"
import Deals from "@/components/Deals.vue"
import { Article } from '@/classes/Articles'

export default defineComponent({
    name: "giftlist",
    components: {
        Articles,
        Deals
    },
    setup() {
        const route = useRoute()
        const router = useRouter()
        const isParticipant = ref(false)
        const isLoading = ref(false)
        const articleDetails = ref<Article | null>(null)
        const articleUrl = ref<string | null>(null)
        const isClean = ref(false)

        const init = async () => {
            isLoading.value = true
            const articleId = Number(route.params.id)
            articleDetails.value = null

            try {
                const response = await api.getArticleDetails(articleId, true)
                const responseData = response.data
                const tmpArticleDetails = response.data
                tmpArticleDetails.imgUrl = 'https://' + settings.siteUrl + tmpArticleDetails.imgUrl

                articleDetails.value = responseData
                document.title = articleDetails.value.pageTitle + ' | ' + settings.siteNameCaps
            } finally {
                isLoading.value = false
            }
        }

        onMounted(() => {
            const cookie_lastref = document.cookie.split('; ').find(row => row.startsWith('MMD_ParticipantRefCode='))
            if (cookie_lastref) {
                isParticipant.value = true
            }

            isClean.value = !!route.query.direct
            init()
        })

        return {
            isParticipant,
            isLoading,
            articleDetails,
            articleUrl,
            isClean,
            linkToJoinWhatsAppGroup: settings.socialLinks.whatsapp
        }
    }
})
</script>
